/**
 * DetectAdBlockController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Utility.DetectAdBlockController = function () {
    window.onload = function () {
        setTimeout(function () {
            function isEmpty(el) {
                return !$.trim(el.html());
            }
            if (isEmpty($('.ad > div'))) {
                // $html.addClass('nA');
            }
        }, 2000);
    };
};
